export const SETTINGS_TABS = {
    AUDIO: 'audio_tab',
    CALENDAR: 'calendar_tab',
    MORE: 'more_tab',
    MODERATOR: 'moderator-tab',
    NOTIFICATIONS: 'notifications_tab',
    PROFILE: 'profile_tab',
    SHORTCUTS: 'shortcuts_tab',
    VIDEO: 'video_tab',
    VIRTUAL_BACKGROUND: 'virtual-background_tab'
};
/**
 * 个人资料邮箱格式（空值视为未填写，由校验函数单独放行）。
 */
export const SETTINGS_EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
/**
 * 会中快捷键说明目录（门户未入会时 shortcutsHelp 为空，用此清单与会中对齐）。
 * 键为展示用按键，值为 i18n key。
 */
export const DEFAULT_SHORTCUTS_HELP = [
    ['?', 'keyboardShortcuts.toggleShortcuts'],
    ['SPACE', 'keyboardShortcuts.pushToTalk'],
    ['0', 'keyboardShortcuts.focusLocal'],
    ['1-9', 'keyboardShortcuts.focusRemote'],
    ['M', 'keyboardShortcuts.mute'],
    ['V', 'keyboardShortcuts.videoMute'],
    ['A', 'toolbar.callQuality'],
    ['C', 'keyboardShortcuts.toggleChat'],
    ['D', 'keyboardShortcuts.toggleScreensharing'],
    ['F', 'keyboardShortcuts.toggleFilmstrip'],
    ['P', 'keyboardShortcuts.toggleParticipantsPane'],
    ['R', 'keyboardShortcuts.raiseHand'],
    ['S', 'keyboardShortcuts.fullScreen'],
    ['T', 'keyboardShortcuts.showSpeakerStats'],
    ['W', 'toolbar.tileViewToggle']
];
/**
 * Default frame rate to be used for capturing screenshare.
 */
export const SS_DEFAULT_FRAME_RATE = 5;
/**
 * Supported framerates to be used for capturing screenshare.
 */
export const SS_SUPPORTED_FRAMERATES = [5, 15, 30];
